import { SupportedChainId } from 'constants/chains'
import { SCUSD } from 'constants/tokens'
import { useTokenBalance } from 'lib/hooks/useCurrencyBalance'
import { useMemo } from 'react'

import useActiveWeb3React from './useActiveWeb3React'

const useStakedCUSDBalance = (account: string | undefined) => {
  const { chainId } = useActiveWeb3React()
  const token = SCUSD[chainId || SupportedChainId.SONIC]
  const address = useMemo(() => account, [account])
  return useTokenBalance(address, token)
}

export default useStakedCUSDBalance
